import React, { useState, useEffect } from 'react';
import ProfileBanner from './ProfileBanner';
import ProfileFeed from './ProfileFeed';
import axios from 'axios';
import WaiverModal from '../league/WaiverModal';
// import ProfileSidebarRight from './ProfileSidebarRight';

function ProfilePage({ activeLeague, setActiveLeague, activeSeason, setActiveSeason, registrationSeason }) {
  const [user, setUser] = useState(null);
  const [showWaiverModal, setShowWaiverModal] = useState(false);

  useEffect(() => {
    // Fetch user data
    axios.get('/api/users/my-details/', {
      withCredentials: true,
    })
      .then(response => {
        setUser(response.data);
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      });

  }, []);

  useEffect(() => {
    if (!activeSeason?.id) {
      setShowWaiverModal(false);
      return;
    }

    async function checkWaiverStatus() {
      try {
        const waiverRes = await fetch(`/api/leagues/check-waiver-status/${activeSeason.id}/`, { credentials: 'include' });
        const waiverData = await waiverRes.json();
        setShowWaiverModal(Boolean(waiverData.waiver_required));
      } catch (err) {
        console.error('Error checking waiver status:', err);
        setShowWaiverModal(false);
      }
    }

    checkWaiverStatus();
  }, [activeSeason?.id]);

  return (
    <>
      <WaiverModal
        show={showWaiverModal}
        seasonId={activeSeason?.id}
        onAgreed={() => setShowWaiverModal(false)}
      />
      {/* Banner row */}
      <div className="row">
        <ProfileBanner
          activeLeague={activeLeague}
          setActiveLeague={setActiveLeague}
          activeSeason={activeSeason}
          setActiveSeason={setActiveSeason}
        />
      </div>

      {/* Feed row */}
      <div className="row mt-3">
        <ProfileFeed
          user={user}
          activeLeague={activeLeague}
          activeSeason={activeSeason}
          registrationSeason={registrationSeason}
        />
        {/* <ProfileSidebarRight /> */}
      </div>
    </>
  );
}

export default ProfilePage;
